export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_SORT_FIELD = 'SET_SORT_FIELD';
export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const SET_DEFAULT_SORT_SEARCH = 'SET_DEFAULT_SORT_SEARCH';
